.bottomContainer {
  align-items: center;
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  order: 3;
  margin-bottom: 30px;

  @media (--mobile-viewport) {
    border-top: 1px solid #eee;
    padding-top: 20px;
  }
}
